export default __webpack_public_path__ + "static/media/rightArrow.6d05f05a.svg";